<template>
  <div>
    {{ this.vnChang }}
    <b-alert
      show
      variant="dark"
      class="margin-bottom font12px icon-dark-custom"
      v-if="this.TmpVisitData"
    >
      <h5 class="font-color-white1">
        วันที่ตรวจ
        {{ this.thaiDatetimeFc.ThaiDate(this.TmpVisitData.datas.vstdate) }}
        {{ this.TmpVisitData.datas.vsttime }}
        <b-badge
          href="#"
          variant="success"
          @click="$bvModal.show('bv-modal-appointment')"
          >แสดงรายการนัดหมาย</b-badge
        >

        <b-modal
          id="bv-modal-appointment"
          size="xl"
          scrollable
          :no-close-on-backdrop="true"
          :close-on-esc="true"
          hide-footer
        >
          <template slot="modal-title">
            รายการนัดหมาย
          </template>
          <div class="d-block margin-bottom">
            <b-alert show variant="light" class="pj_clearfix">
              <div class="overflow-auto">
                <b-table
                  striped
                  hover
                  small
                  :items="this.TmpAppointmentData"
                  :fields="this.TmpAppointmentfieldsData"
                  :sort-by.sync="sortBy"
                  :sort-asc.sync="sortDesc"
                  class="font13px"
                  style="min-width: 800px;"
                >
                </b-table>
              </div>
            </b-alert>
          </div>
          <div class="d-block text-center">
            <b-button
              variant="info"
              size="sm"
              class="d-print-none"
              v-print="'#bv-modal-appointment'"
            >
              Print
            </b-button>
            &nbsp;
            <b-button
              size="sm"
              class="d-print-none"
              @click="$bvModal.hide('bv-modal-appointment')"
              >Close</b-button
            >
          </div>
        </b-modal>
        &nbsp;&nbsp;
        <b-badge href="#" variant="warning" @click="ConsentOpen()"
          >Consent</b-badge
        >
      </h5>
      <div class="font-color-white1">
        <h6 class="font-color-white1">
          ห้องตรวจ : {{ this.TmpVisitData.datas.department_name }}
        </h6>
        <h6 class="font-color-white1" v-show="TmpVisitData.datas.an">
          ประวัติ Admit :
          <b-badge
            variant="danger"
            class="font14px cursor-pointer"
            @click="selectAN(TmpVisitData.datas.an)"
            >AN : {{ TmpVisitData.datas.an }}</b-badge
          >
        </h6>
        <strong>
          <hr class="hr-custom" />
          <div>
            สิทธิการรักษาในวันนี้ :
            {{
              this.pjFunctionsFc.NulltoStr(this.TmpVisitData.datas.pttype) +
              " " +
              this.pjFunctionsFc.NulltoStr(this.TmpVisitData.datas.pttype_name)
            }}
          </div>
          <div>
            สถานพยาบาลหลัก :
            {{
              this.pjFunctionsFc.NulltoStr(this.TmpVisitData.datas.hospmain) +
              " " +
              this.pjFunctionsFc.NulltoStr(
                this.TmpVisitData.datas.hospmain_name
              )
            }}
          </div>
          <div>
            สถานพยาบาลรอง :
            {{
              this.pjFunctionsFc.NulltoStr(this.TmpVisitData.datas.hospsub) +
              " " +
              this.pjFunctionsFc.NulltoStr(this.TmpVisitData.datas.hospsub_name)
            }}
          </div>
          <div>
            Begin :
            {{
              this.thaiDatetimeFc.ThaiDate(
                this.TmpVisitData.datas.pttype_begin
              ) +
              " | Expire : " +
              this.thaiDatetimeFc.ThaiDate(
                this.TmpVisitData.datas.pttype_expire
              )
            }}
          </div>

          <div v-if="this.TmpDoctorTreatment">
            <hr class="hr-custom" />
            แพทย์ผู้ทำการรักษา :
            <b-badge
              class="font12px margin-right4px"
              variant="primary"
              v-for="item in this.TmpDoctorTreatment"
              v-bind:key="item.id"
            >
              {{ item.datas.doctor_name }}
            </b-badge>
          </div>
          <hr class="hr-custom" />
          <div>การเงิน</div>
          <div v-if="this.TmpVisitData">
            <b-badge
              class="font12px font-color-dark1"
              variant="warning"
              v-if="this.TmpVisitData.datas.rcpno"
            >
              ใบเสร็จ เล่มที่/เลขที่ : {{ this.TmpVisitData.datas.rcpno }} |
              ออกใบเสร็จ : {{ this.TmpVisitData.datas.bill_amount }}
            </b-badge>
          </div>
          <hr class="hr-custom" />
        </strong>
      </div>
      <!-- 
      <div style="padding-left:8px;padding-right:8px;" v-show="false">
        <b-row >

          <b-col
            lg="12"
          >
            <h4 class="font-color-white1" >ห้องปฏิบัติการ (Lab)</h4>

            

              <EmrReportBTR 
              v-if="this.$store.get('systems@ApiKey')"
              v-bind:my-vn="this.$store.get('systems@vnEMR')"
              v-bind:my-hn="this.$store.get('systems@hnEMR')"
              v-bind:my-an="this.$store.get('systems@anEMR')" ></EmrReportBTR>

            <hr class="hr-custom">
            
          </b-col>
        </b-row>
      </div>
      -->
      <div style="padding-left: 8px; padding-right: 8px;">
        <b-row>
          <b-col lg="5" v-show="false">
            <h4 class="font-color-white1">ทันตกรรม</h4>
            <b-modal
              id="modal-dental-history"
              title="ประวัติทันตกรรม"
              size="xl"
              ok-only
              button-size="sm"
              scrollable
              :no-close-on-backdrop="true"
              :close-on-esc="true"
            >
              <div
                v-for="item in getDentalData(ptHN)"
                v-bind:key="item.id"
                style="margin-bottom: 4px;"
              >
                <b-alert show variant="warning" class="font14px">
                  <h5>
                    <b-badge variant="danger"
                      >วันที่ :
                      {{ thaiDatetimeFc.ThaiDate(item.vstdate) }}</b-badge
                    >
                  </h5>
                  <hr class="hr-custom" />
                  <b-row>
                    <b-col lg="6">
                      <b-alert show variant="primary">
                        <b-badge variant="primary">CC :</b-badge>
                        {{ item.CcPeText[0].cc }}
                      </b-alert>
                    </b-col>
                    <b-col lg="6">
                      <b-alert show variant="primary">
                        <b-badge variant="primary">PE :</b-badge>
                        {{ item.CcPeText[0].pe }}
                      </b-alert>
                    </b-col>
                  </b-row>
                  <hr class="hr-custom" />
                  <div
                    v-for="item2 in item.dentalData[0].DentalData"
                    v-bind:key="item2.id"
                  >
                    <b-alert show variant="success">
                      <b-row>
                        <b-col lg="8">
                          {{ item2.datas.tmname }}
                        </b-col>
                        <b-col lg="4">
                          <b-badge variant="success">ผู้รักษา :</b-badge>
                          {{ item2.datas.doctor_name }}
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col lg="2">
                          <b-badge variant="success">ICD10 :</b-badge>
                          {{ item2.datas.icd }}
                        </b-col>
                        <b-col lg="2">
                          <b-badge variant="success">ICD9 :</b-badge>
                          {{ item2.datas.icd9 }}
                        </b-col>
                        <b-col lg="4">
                          <b-badge variant="success">หมายเหตุ :</b-badge>
                          {{ item2.datas.note }}
                        </b-col>
                        <b-col lg="4">
                          <b-badge variant="success">Dental Note :</b-badge>
                          {{ item2.datas.dental_note }}
                        </b-col>
                      </b-row>
                      <div
                        v-for="item3 in getDentalAreaData(
                          item2.vn,
                          item2.hn,
                          item2.dtmain_id
                        )"
                        v-bind:key="item3.id"
                      >
                        <hr class="hr-custom" />
                        <b-row>
                          <b-col lg="2">
                            <b-badge variant="success">Area. :</b-badge>
                            {{ item3.datas.dtarea_name }}
                          </b-col>
                          <b-col lg="2">
                            <b-badge variant="success">Ext. :</b-badge>
                            {{ item3.datas.ext_code }}
                          </b-col>
                          <b-col lg="2">
                            <b-badge variant="success">ICD10tm :</b-badge>
                            {{ item3.datas.icd10tm_operation_code }}
                          </b-col>
                          <b-col lg="6">
                            <b-badge variant="success">ICD10tm name :</b-badge>
                            {{ item3.datas.description_english }}
                          </b-col>
                        </b-row>
                      </div>
                    </b-alert>
                    <hr class="hr-custom" />
                  </div>
                </b-alert>
              </div>
            </b-modal>
            <b-button
              size="sm"
              variant="info"
              class="d-print-none"
              @click="setVitalSign($store.get('systems@hnEMR'))"
              >ประวัติทันตกรรม</b-button
            >
          </b-col>
          <b-col lg="7" v-show="false">
            <h4 class="font-color-white1">ห้องยา</h4>

            <b-modal
              id="modal-phamarcy-adr"
              title="Adverse Drug Reaction (ADR)"
              size="xl"
              ok-only
              scrollable
              class="d-print-none"
              :no-close-on-backdrop="true"
              :close-on-esc="true"
              button-size="sm"
            >
              <b-row>
                <b-col lg="12">
                  <div
                    v-for="(item, index) in getPhamarcyADRData(ptHN)"
                    v-bind:key="item.id"
                  >
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <h5>
                        <b-badge
                          variant="warning"
                          href="#"
                          v-b-toggle="'D' + index"
                        >
                          ครั้งที่ ( {{ item.datas.adverse_number }} ) |
                          {{
                            thaiDatetimeFc.ThaiDateTime(
                              item.datas.regdate + " " + item.datas.regtime
                            )
                          }}
                        </b-badge>
                      </h5>
                    </b-card-header>
                    <b-collapse
                      :id="'D' + index"
                      accordion="my-adr"
                      role="tabpanel-adr"
                      :visible="index == 0"
                    >
                      <b-alert show variant="dark">
                        <b-card
                          header="อาการไม่พึงประสงค์จากการใช้ยา"
                          header-text-variant="white"
                          header-tag="header"
                          header-bg-variant="danger"
                          text-variant="dark"
                        >
                          <b-card-text>
                            <h6>
                              <b-badge variant="primary"
                                >สรุปรายการยาที่แพ้ :</b-badge
                              >
                            </h6>
                            {{ item.datas.summary_drug }}
                            <hr class="hr-custom" />
                            <h6>
                              <b-badge variant="primary"
                                >Pharmacist Note :</b-badge
                              >
                            </h6>
                            {{ item.datas.pharmacist_note }}
                            <hr class="hr-custom" />

                            ครั้งที่ ( {{ item.datas.adverse_number }} ) |
                            {{
                              thaiDatetimeFc.ThaiDateTime(
                                item.datas.regdate + " " + item.datas.regtime
                              )
                            }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary"
                                >ประเภทผู้ป่วย :</b-badge
                              >
                            </h6>
                            {{ item.datas.pt_type }} | WARD :
                            {{ item.datas.ward }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary"
                                >ประเภทบริการ :</b-badge
                              >
                            </h6>
                            {{ item.datas.phamarcy_service_type_name }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary"
                                >Suspected drug(s) :</b-badge
                              >
                            </h6>
                            {{ item.datas.adverse_suspected }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary"
                                >Concomitant drug(s) :</b-badge
                              >
                            </h6>
                            {{ item.datas.adverse_concomitant }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary">ADR :</b-badge>
                            </h6>
                            {{ item.datas.adverse_adr }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary"
                                >Probability assessment ( Naranjo's score =
                                )</b-badge
                              >
                            </h6>
                            <label v-if="item.datas.adverse_unlikely != ''">
                              ( unlikely )
                            </label>
                            <label v-if="item.datas.adverse_possible != ''">
                              ( possible )
                            </label>
                            <label v-if="item.datas.adverse_probable != ''">
                              ( probable )
                            </label>
                            <label v-if="item.datas.adverse_certain != ''">
                              ( certain )
                            </label>
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary">Severity :</b-badge>
                            </h6>
                            <label v-if="item.datas.adverse_mild != ''">
                              ( mild )
                            </label>
                            <label v-if="item.datas.adverse_moderate != ''">
                              ( moderate )
                            </label>
                            <label v-if="item.datas.adverse_severe != ''">
                              ( severe )
                            </label>
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary"
                                >Intervention :</b-badge
                              >
                            </h6>
                            <label v-if="item.datas.adverse_guide != ''">
                              ( แนะนำ )
                            </label>
                            <label v-if="item.datas.adverse_outcard != ''">
                              ( ออกบัตรแพ้ยา )
                            </label>
                            <label
                              v-if="item.datas.adverse_warning_outcard != ''"
                            >
                              ( ออกบัตรเตือนอาการข้างเคียง )
                            </label>
                            <label v-if="item.datas.adverse_other != ''">
                              ( อื่นๆ ) :
                              {{ item.datas.adverse_other_text }}</label
                            >
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary">Suggestion :</b-badge>
                            </h6>
                            {{ item.datas.adverse_suggestion }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary">ติดตาม :</b-badge>
                            </h6>
                            <label v-if="item.datas.adverse_track_std == 'Y'">
                              ( ไม่ติดตาม )
                            </label>
                            <label v-if="item.datas.adverse_track_std != 'Y'">
                              ( ติดตามวันที่ :
                              {{
                                thaiDatetimeFc.ThaiDate(
                                  item.datas.adverse_track_date
                                )
                              }}
                              )
                            </label>
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary">เภสัชกร :</b-badge>
                            </h6>
                            {{ item.datas.adverse_phamarcy }}
                          </b-card-text>
                        </b-card>

                        <hr class="hr-custom" />

                        <b-card
                          header="ข้อมูลการซักประวัติย้อนหลัง ' การแพ้ยา ' "
                          header-text-variant="white"
                          header-tag="header"
                          header-bg-variant="success"
                          text-variant="dark"
                        >
                          <b-card-text>
                            <h6>
                              <b-badge variant="primary"
                                >สรุปรายการยาที่แพ้ :</b-badge
                              >
                            </h6>
                            {{ item.datas.history_allergic_summarize }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary"
                                >ประเภทบริการ :</b-badge
                              >
                            </h6>
                            {{
                              item.datas.history_phamarcy_service_result_name
                            }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary"
                                >รายการที่สงสัย :</b-badge
                              >
                            </h6>
                            {{ item.datas.history_allergic_drug_doubt }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary">อาการ :</b-badge>
                            </h6>
                            {{ item.datas.history_allergic_symptom }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary">สรุป :</b-badge>
                            </h6>
                            {{ item.datas.phamarcy_service_result_name }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary">ดำเนินการ :</b-badge>
                            </h6>
                            <label
                              v-if="item.datas.history_allergic_outcard != ''"
                            >
                              ( ออกบัตรซักประวัติเรื่องการแพ้ยา )
                            </label>
                            <label v-if="item.datas.allergic_outcard != ''">
                              ( ออกบัตรแพ้ยา )
                            </label>
                            <label
                              v-if="item.datas.history_allergic_guide != ''"
                            >
                              ( ให้คำแนะนำ/แผ่นพับ/แอกสารให้ความรู้ )
                            </label>
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary">แนะนำ :</b-badge>
                            </h6>
                            {{ item.datas.history_allergic_guide_text }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary">ติดตาม :</b-badge>
                            </h6>
                            <label
                              v-if="
                                item.datas.history_allergic_track_std == 'Y'
                              "
                            >
                              ( ไม่ติดตาม )
                            </label>
                            <label
                              v-if="
                                item.datas.history_allergic_track_std != 'Y'
                              "
                            >
                              ( ติดตามวันที่ :
                              {{
                                thaiDatetimeFc.ThaiDate(
                                  item.datas.adverse_track_date
                                )
                              }}
                              )
                            </label>
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="primary">เภสัชกร :</b-badge>
                            </h6>
                            {{ item.datas.history_allergic_phamacy }}
                          </b-card-text>
                        </b-card>
                      </b-alert>
                    </b-collapse>
                    <hr class="hr-custom" />
                  </div>
                </b-col>
              </b-row>
            </b-modal>

            <b-modal
              id="modal-drug-counseling"
              title="Drug Counseling"
              size="xl"
              ok-only
              scrollable
              class="d-print-none"
              :no-close-on-backdrop="true"
              :close-on-esc="true"
              button-size="sm"
            >
              <b-row>
                <b-col lg="12">
                  <div
                    v-for="(item, index) in PhamarcyCounseling"
                    v-bind:key="item.id"
                  >
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <h5>
                        <b-badge
                          variant="danger"
                          href="#"
                          v-b-toggle="'DC' + index"
                        >
                          วันที่
                          {{
                            thaiDatetimeFc.ThaiDateTime(
                              item.datas.reg_date + " " + item.datas.reg_time
                            )
                          }}
                        </b-badge>
                      </h5>
                    </b-card-header>
                    <b-collapse
                      :id="'DC' + index"
                      accordion="my-adr"
                      role="tabpanel-adr"
                      :visible="index == 0"
                    >
                      <b-alert show variant="dark">
                        <b-card
                          :header="
                            'วันที่ ' +
                            thaiDatetimeFc.ThaiDateTime(
                              item.datas.reg_date + ' ' + item.datas.reg_time
                            )
                          "
                          header-text-variant="white"
                          text-variant="dark"
                          header-tag="header"
                          header-bg-variant="primary"
                        >
                          <b-card-text>
                            <h6>
                              <b-badge variant="success">ปัญหา :</b-badge>
                            </h6>
                            {{ item.datas.problem_name }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="success"
                                >ประเภทผู้ป่วย :</b-badge
                              >
                            </h6>
                            {{ item.datas.department }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="success"
                                >สิทธการรักษา :</b-badge
                              >
                            </h6>
                            {{ item.datas.counseling_pttype_name }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="success">ส่งจากแผนก :</b-badge>
                            </h6>
                            {{ item.datas.from_department_name }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="success">หมายเหตุ :</b-badge>
                            </h6>
                            {{ item.datas.note }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="success"
                                >เหตุผลในการใช้ยาหรือข้อบ่งใช้ (Indication)
                                :</b-badge
                              >
                            </h6>
                            {{ item.datas.indication }}
                            <hr class="hr-custom" />

                            <h6>
                              <b-badge variant="success">แพทย์ผู้ส่ง :</b-badge>
                            </h6>
                            {{ item.datas.from_docor_name }}
                          </b-card-text>
                        </b-card>
                      </b-alert>
                    </b-collapse>
                    <hr class="hr-custom" />
                  </div>
                </b-col>
              </b-row>
            </b-modal>

            <b-row>
              <b-col lg="6" v-show="false">
                <b-button
                  size="sm"
                  variant="warning"
                  class="d-print-none"
                  v-b-modal.modal-phamarcy-adr
                  >Adverse Drug Reaction (ADR)</b-button
                >
              </b-col>
              <b-col lg="6" v-if="PhamarcyCounseling" v-show="false">
                <b-button
                  size="sm"
                  variant="success"
                  class="d-print-none"
                  v-b-modal.modal-drug-counseling
                  >Drug Counseling</b-button
                >
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row v-show="false">
          <b-col lg="12">
            <hr class="hr-custom" />
            <h4>Audiogram (การตรวจการได้ยิน)</h4>

            <b-col lg="6">
              <b-button
                size="sm"
                class="d-print-none"
                variant="dark"
                @click="earOpenNew(ptVN)"
              >
                <b-img
                  rounded="circle"
                  alt="Audiogram (การตรวจการได้ยิน)"
                  title="Audiogram (การตรวจการได้ยิน)"
                  width="20"
                  class="icon-css"
                  v-bind:src="imgEarHearingCkIcon"
                ></b-img>
                Audiogram (การตรวจการได้ยิน)
              </b-button>
            </b-col>
          </b-col>
        </b-row>
      </div>
      <div class="d-print-none">
        <h6>ประวัติการรักษาอื่นๆ</h6>
        <b-row>
          <b-col class="mr-auto">
            <b-img
              v-if="PtEarHearing(ptVN)"
              thumbnail
              rounded="circle"
              alt="Audiogram (การตรวจการได้ยิน)"
              title="Audiogram (การตรวจการได้ยิน)"
              width="50"
              class="icon-css cursor-pointer margin-right8px"
              style="background-color: #ffffff; padding: 2px;"
              v-bind:src="imgEarHearingCkIcon"
              @click="earOpenNew(ptVN)"
            ></b-img>

            <b-img
              v-show="PhamarcyCounseling"
              thumbnail
              rounded="circle"
              alt="Drug Counseling"
              title="Drug Counseling"
              width="50"
              class="icon-css cursor-pointer margin-right8px"
              style="background-color: #ffffff; padding: 2px;"
              v-bind:src="imgCounseling2Icon"
              v-b-modal.modal-drug-counseling
            ></b-img>

            <b-img
              v-show="
                getPhamarcyADRData(ptHN) != '[]' &&
                getPhamarcyADRData(ptHN) != ''
              "
              thumbnail
              rounded="circle"
              alt="Adverse Drug Reaction (ADR)"
              title="Adverse Drug Reaction (ADR)"
              width="50"
              class="icon-css cursor-pointer margin-right8px"
              style="background-color: #ffffff; padding: 2px;"
              v-bind:src="imgDrugAllergyIcon"
              v-b-modal.modal-phamarcy-adr
            ></b-img>

            <b-img
              v-if="getDentalData(ptHN) != '[]' && getDentalData(ptHN) != ''"
              thumbnail
              rounded="circle"
              alt="ประวัติทันตกรรม"
              title="ประวัติทันตกรรม"
              width="50"
              class="icon-css cursor-pointer margin-right8px"
              style="background-color: #ffffff; padding: 2px;"
              v-bind:src="imgDentalIcon"
              @click="setVitalSign($store.get('systems@hnEMR'))"
            ></b-img>
          </b-col>
        </b-row>
      </div>
    </b-alert>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import PatientData from "@/models/patientEMRs/PatientData";
import PatientVisit from "@/models/patientEMRs/PatientVisit";
import thaiDatetime from "@/functions/thaiDatetime";
import PatientVisitDoctorTreatmentOPD from "@/models/patientEMRs/PatientVisitDoctorTreatmentOPD";
import pjFunctions from "@/functions/pjFunctions";
import PatientAppointmentData from "@/models/patientEMRs/PatientAppointmentData";
import PatientWebbaseUrl from "@/models/patientEMRs/PatientWebbaseUrl";
import PatientEmrEarHearingDetail from "@/models/patientEMRs/PatientEmrEarHearingDetail";

import PatientDentalData from "@/models/patientEMRs/PatientDentalData";
import PatientDentalAreaData from "@/models/patientEMRs/PatientDentalAreaData";
import PatientDentalVisitData from "@/models/patientEMRs/PatientDentalVisitData";
import PatientScreening from "@/models/patientEMRs/PatientScreening";
import PatientPhamarcyADR from "@/models/patientEMRs/PatientPhamarcyADR";
import PatientPhamarcyCounseling from "@/models/patientEMRs/PatientPhamarcyCounseling";
import EmrReportBTR from "@/components/PatientEMR/EmrReportBTR";
const EarHearingCkIcon = require("@/images/EarHearing-Icon.png");
const Counseling2Icon = require("@/images/counseling2.png");
const DrugAllergyIcon = require("@/images/Drug_Allergy-512.png");
const DentalIcon = require("@/images/whitening-512.png");

Vue.component("EmrReportBTR", EmrReportBTR);

Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      ptImage: "",
      visitData: null,
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      TmpVisitData: null,
      TmpDoctorTreatment: null,
      TmpAppointmentData: null,
      TmpAppointmentfieldsData: null,
      apiCk: 0,
      sortBy: "numbers",
      sortDesc: true,
      stream: null,
      ptHN: "",
      ptVN: "",
      DataCh: "",
      DentalVisitData: null,
      PhamarcyCounseling: null,
      imgEarHearingCkIcon: EarHearingCkIcon,
      imgCounseling2Icon: Counseling2Icon,
      imgDrugAllergyIcon: DrugAllergyIcon,
      imgDentalIcon: DentalIcon,
      EarUrl: "",
      UserID: "",
      ConsentURL: "",
    };
  },
  props: ["MyVn", "MyHn"],
  component: {
    PatientData,
    PatientVisit,
    thaiDatetime,
    PatientVisitDoctorTreatmentOPD,
    pjFunctions,
    PatientDentalData,
    PatientDentalAreaData,
    PatientDentalVisitData,
    PatientScreening,
    PatientPhamarcyADR,
    PatientPhamarcyCounseling,
    PatientEmrEarHearingDetail,
  },
  created() {
    this.hnChangVisit,
      (this.thaiDatetimeFc = thaiDatetime.methods),
      (this.pjFunctionsFc = pjFunctions.methods);
    this.vnChang;
  },
  watch: {
    ptHN: function () {
      // this.setData(this.ptVN,this.ptHN)
    },
    ptVN: function () {
      this.setData(this.ptVN, this.ptHN);
    },
    DataCh: function () {
      this.getData(this.ptVN, this.ptHN);
    },
  },
  computed: {
    vnChang() {
      this.ptHN = this.MyHn;
      this.ptVN = this.MyVn;
    },
  },
  methods: {
    setData(vn, hn) {
      if (vn != "" && vn != null) {
        let hnCk = hn;

        this.ConsentURL = PatientWebbaseUrl.query()
          .where((record) => record.web_name == "EMR_Consent")
          .where((record) => record.datas.web_status == "Y")
          .get()[0];

        let ScrObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "VisitOPDDoctorTreatment", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hnCk,
            vn: vn,
          })
          .then(function (response) {
            ScrObj.output = response.data;
            if (ScrObj.output.status === true) {
              PatientVisitDoctorTreatmentOPD.delete({
                where(record) {
                  return record.vn == vn;
                },
              });

              let data = [];
              for (var val of ScrObj.output.result) {
                data.push({
                  id: val.pq_doctor_id,
                  pq_doctor_id: val.pq_doctor_id,
                  hn: val.hn,
                  vn: val.vn,
                  datas: val,
                });
              }

              PatientVisitDoctorTreatmentOPD.insertOrUpdate({
                data,
              });
            } else {
              if (ScrObj.output.ErrorMessage === "Data Not Found") {
                PatientVisitDoctorTreatmentOPD.delete({
                  where(record) {
                    return record.vn == vn;
                  },
                });
              }
            }
          })
          .catch(function (error) {
            ScrObj.output = error;
            console.log("VisitOPDDoctorTreatment : " + ScrObj.output);
          })
          .finally(function () {
            ScrObj.DataCh = "VisitOPDDoctorTreatment" + vn;
          });
      }
    },
    getData(vn, hn) {
      let WebbaseUrl = PatientWebbaseUrl.query()
        .where((record) => record.web_name == "EAR_EMR")
        .get();

      if (WebbaseUrl.length > 0) {
        this.EarUrl = WebbaseUrl[0].web_host;
      }

      let ScrObj = PatientVisit.query()
        .where((record) => record.datas.hn == hn)
        .where((record) => record.datas.vn == vn)
        .get();

      if (ScrObj.length > 0) {
        this.TmpVisitData = ScrObj[0];
        this.apiCk = this.apiCk + 1;
      } else {
        this.TmpVisitData = null;
        this.apiCk = this.apiCk + 1;
      }

      let ScrObj2 = PatientVisitDoctorTreatmentOPD.query()
        .where((record) => record.datas.hn == hn)
        .where((record) => record.datas.vn == vn)
        .get();

      if (ScrObj2.length > 0) {
        this.TmpDoctorTreatment = ScrObj2;
        this.apiCk = this.apiCk + 1;
      } else {
        this.TmpDoctorTreatment = null;
        this.apiCk = this.apiCk + 1;
      }

      let ScrObj3 = PatientAppointmentData.query()
        .where((record) => record.datas.hn == hn)
        .orderBy("list_orderby", "desc")
        .get();

      let AppointmentData = [];

      for (let i = 0; i < ScrObj3.length; i++) {
        AppointmentData.push({
          numbers: i + 1,
          nextdatetime: this.thaiDatetimeFc.ThaiDateTime(
            ScrObj3[i].datas.nextdate + " " + ScrObj3[i].datas.nexttime
          ),
          clinic_name: ScrObj3[i].datas.clinic_name,
          doctor_name: ScrObj3[i].datas.doctor_name,
          note: ScrObj3[i].datas.note,
          app_user: ScrObj3[i].datas.app_user,
        });
      }

      let AppointmentfieldsData = [
        { label: "ลำดับ", key: "numbers", sortable: true },
        { label: "วันที่พบแพทย์", key: "nextdatetime", sortable: true },
        { label: "คลินิก", key: "clinic_name", sortable: true },
        { label: "แพทย์", key: "doctor_name", sortable: true },
        { label: "โน๊ต", key: "note", sortable: true },
        { label: "ผู้ทำนัด", key: "app_user", sortable: true },
      ];

      if (ScrObj3.length > 0) {
        this.TmpAppointmentData = AppointmentData;
        this.TmpAppointmentfieldsData = AppointmentfieldsData;
        this.apiCk = this.apiCk + 1;
      } else {
        this.TmpAppointmentData = null;
        this.TmpAppointmentfieldsData = null;
        this.apiCk = this.apiCk + 1;
      }

      let PhamarcyCounselingObj = PatientPhamarcyCounseling.query()
        .where((record) => record.datas.hn == hn)
        .get();

      if (PhamarcyCounselingObj.length > 0) {
        this.PhamarcyCounseling = PhamarcyCounselingObj;
        // console.log(this.PhamarcyCounseling)
      } else {
        this.PhamarcyCounseling = null;
      }
    },
    getDentalData(hn) {
      let ScrObj4 = PatientDentalVisitData.query()
        .where("hn", hn)
        .orderBy("vstdate", "desc")
        .get();

      let data1 = [];
      let DentalData = [];
      let DentalDataAll = [];

      let data = [];
      let VitalSignObj = this;

      for (var val2 of ScrObj4) {
        DentalDataAll = [];
        DentalData = [];
        DentalData = PatientDentalData.query()
          .where("vn", val2.vn)
          .where("hn", val2.hn)
          .get();

        /*
                

              */

        /*
          DentalAreaData = []
          for (var val3 of DentalData) {
            
            DentalAreaData = PatientDentalAreaData.query()
            .where('vn', val3.vn)
            .where('hn', val3.hn)
            .where('dtmain_id', val3.dtmain_id)
            .get()

          } 

          DentalData.push({
            DentalAreaData: DentalAreaData
          })*/

        DentalDataAll.push({
          DentalData: DentalData,
        });

        let peText = PatientScreening.query()
          .where("vn", val2.vn)
          .where("hn", val2.hn)
          .get();

        let CcPeText = [];

        if (peText.length > 0) {
          CcPeText.push({
            cc: peText[0].datas.cc,
            pe: peText[0].datas.pe,
          });
        } else {
          CcPeText.push({
            cc: "",
            pe: "",
          });
        }

        data1.push({
          id: val2.hn + val2.vn,
          vn: val2.vn,
          hn: val2.hn,
          vstdate: val2.vstdate,
          vsttime: val2.vsttime,
          dentalData: DentalDataAll,
          CcPeText: CcPeText,
        });
      }

      return data1;
    },
    getCcPe(vn, hn) {
      let peText = PatientScreening.query()
        .where("vn", vn)
        .where("hn", hn)
        .get();

      let CcPeText = [];

      if (peText.length > 0) {
        CcPeText.push({
          cc: peText[0].datas.cc,
          pe: peText[0].datas.pe,
        });
      } else {
        CcPeText.push({
          cc: "",
          pe: "",
        });
      }

      return CcPeText;
    },
    getDentalAreaData(vn, hn, dtmain_id) {
      let DentalAreaData = PatientDentalAreaData.query()
        .where("vn", vn)
        .where("hn", hn)
        .where("dtmain_id", dtmain_id)
        .get();

      return DentalAreaData;
    },
    getPhamarcyADRData(hn) {
      let PhamarcyADRData = PatientPhamarcyADR.query().where("hn", hn).get();

      return PhamarcyADRData;
    },

    earOpenNew(vn) {
      this.UserID = this.$store.get("systems@LoginData").UserId;
      window.open(
        this.EarUrl + "?vn=" + vn + "&users=" + this.UserID,
        "Audiogram" + vn
      );
    },

    PtEarHearing(vn) {
      if (PatientEmrEarHearingDetail.query().where("vn", vn).get()[0]) {
        let PtEmrEarHearingDetailObj = PatientEmrEarHearingDetail.query()
          .where(
            (record) => record.datas.hn == this.$store.get("systems@hnEMR")
          )
          .where((record) => record.datas.vn == vn)
          .get();

        if (PtEmrEarHearingDetailObj != "") {
          return PtEmrEarHearingDetailObj[0].datas;
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    setVitalSign(hn) {
      let data = [];

      let VitalSignObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "VisitOPDVitalSign", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
        })
        .then(function (response) {
          VitalSignObj.output = response.data;
          if (VitalSignObj.output.status === true) {
            PatientScreening.delete({
              where(record) {
                return record.hn == hn;
              },
            });

            data = [];
            for (var val of VitalSignObj.output.result) {
              data.push({
                id: val.vn,
                vn: val.vn,
                hn: val.hn,
                datas: val,
              });
            }

            PatientScreening.insertOrUpdate({
              data,
            });
          }
        })
        .catch(function (error) {
          VitalSignObj.output = error;
          console.log("VisitOPDVitalSign : " + VitalSignObj.output);
        })
        .finally(function () {
          VitalSignObj.$bvModal.show("modal-dental-history");
        });
    },
    selectAN(an) {
      store.set("systems@anEMR", an);
      setTimeout(() => {
        // v-b-modal.modal-admit-data
        this.$bvModal.show("modal-admit-data");
      }, 200);
    },
    ConsentOpen() {
      let an1 = "";

      if (this.TmpVisitData.datas.an) {
        an1 = this.TmpVisitData.datas.an;
      }

      window.open(
        this.ConsentURL.web_host + "?vn=" + this.ptVN + "&an=" + an1,
        "_blank"
      );
    },
  },
})
export default class EmrVisitDetailData extends Vue {}
</script>

<style lang="scss">
.alert {
  margin-bottom: 0px !important;
}

.icon-css {
  margin-right: 4px;
  float: left;
}
</style>

